export default ($) => {
  $('.js-accordion').each(function () {
    const $accordion = $(this);

    $accordion.find('.js-accordion-header').on('click', function () {
      const $item = $(this).closest('.js-accordion-item');

      if ($item.hasClass('active')) {
        $item.removeClass('active');
      } else {
        $accordion.find('.js-accordion-item').removeClass('active');

        $item.addClass('active');
      }
    });
  });
}